import script from "./TrainingPlanEdit.vue?vue&type=script&setup=true&lang=js"
export * from "./TrainingPlanEdit.vue?vue&type=script&setup=true&lang=js"

import "./TrainingPlanEdit.vue?vue&type=style&index=0&id=3ed51cf6&lang=css"
import "./TrainingPlanEdit.vue?vue&type=style&index=1&id=3ed51cf6&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Utilizador\\Desktop\\projetos\\owlpharma-hrm\\src\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3ed51cf6"]])

export default __exports__